import { Grid } from "@mui/system";
import { Typography } from "@mui/material";

import ClicksWithFtdTable, { FTD_COLUMNS } from "./ClickswithFtdTable";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const ClicksWithFtd = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const zeroPerformanceFtdData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.zeroPerformanceFtdData,
  );

  const zeroPerformanceFtdMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.zeroPerformanceFtdMetadata,
  );

  const isFetchedForFtdData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForFtdData,
  );

  //-- Extract unique brand names for Autocomplete filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (zeroPerformanceFtdData || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [zeroPerformanceFtdData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return zeroPerformanceFtdData;
    return zeroPerformanceFtdData.filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [zeroPerformanceFtdData, choosenBrand]);

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            5+ Clicks with 0 FTD in the Last 7 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="876"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="874"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                FTD_COLUMNS,
                "zero-performance-ftd.csv",
              )
            }
            disabled={
              zeroPerformanceFtdData.length === 0 || !isFetchedForFtdData
            }
          />
        </Grid>
      </Grid>
      <ClicksWithFtdTable
        metadata={zeroPerformanceFtdMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default ClicksWithFtd;
